const AMENITIES_DATA = [
  {
    id: "bagno", label: "Bagno", emoji: "🛁",
    items: [
      { id: "asciugacapelli", emoji: "💨", label: "Asciugacapelli" },
      { id: "shampoo", emoji: "🧴", label: "Shampoo" },
      { id: "balsamo", emoji: "🧴", label: "Balsamo" },
      { id: "gel_doccia", emoji: "🚿", label: "Gel doccia" },
      { id: "sapone_corpo", emoji: "🧼", label: "Sapone per il corpo" },
      { id: "sapone_mani", emoji: "🧼", label: "Sapone per le mani" },
      { id: "prodotti_pulizia", emoji: "🧹", label: "Prodotti per la pulizia" },
      { id: "bide", emoji: "🚽", label: "Bidè" },
      { id: "acqua_calda", emoji: "🌡️", label: "Acqua calda" },
      { id: "vasca", emoji: "🛁", label: "Vasca da bagno" },
      { id: "vasca_idromassaggio", emoji: "💦", label: "Vasca idromassaggio / Jacuzzi" },
      { id: "doccia_separata", emoji: "🚿", label: "Doccia separata" },
      { id: "doccia_pioggia", emoji: "🌧️", label: "Doccia a pioggia" },
      { id: "box_doccia_vetro", emoji: "🔲", label: "Box doccia in vetro" },
      { id: "specchio_illuminato", emoji: "💡", label: "Specchio illuminato" },
      { id: "specchio_ingranditore", emoji: "🔍", label: "Specchio ingranditore" },
      { id: "asciugamani_bagno", emoji: "🪥", label: "Asciugamani da bagno" },
      { id: "asciugamani_piscina", emoji: "🏊", label: "Asciugamani da piscina / spiaggia" },
      { id: "accappatoio", emoji: "🥼", label: "Accappatoio" },
      { id: "ciabatte", emoji: "🩴", label: "Ciabatte da bagno" },
      { id: "doppio_lavandino", emoji: "🚰", label: "Doppio lavandino" },
      { id: "bagno_en_suite", emoji: "🚪", label: "Bagno en suite (in camera)" },
      { id: "secondo_bagno", emoji: "🚿", label: "Secondo bagno" },
      { id: "terzo_bagno", emoji: "🚿", label: "Terzo bagno" },
      { id: "wc_separato", emoji: "🚽", label: "WC separato" },
      { id: "kit_cortesia", emoji: "🎁", label: "Kit di cortesia" },
      { id: "dentifricio_spazzolino", emoji: "🪥", label: "Dentifricio e spazzolino usa e getta" },
      { id: "rasoi", emoji: "🪒", label: "Rasoi usa e getta" },
      { id: "crema_corpo", emoji: "🧴", label: "Crema idratante corpo" },
      { id: "cuffia_doccia", emoji: "🎓", label: "Cuffia da doccia" },
      { id: "scaldasalviette", emoji: "♨️", label: "Scaldasalviette" },
    ],
  },
  {
    id: "camera", label: "Camera da letto", emoji: "🛏️",
    items: [
      { id: "letto_matrimoniale", emoji: "🛏️", label: "Letto matrimoniale Queen" },
      { id: "letto_king", emoji: "🛏️", label: "Letto King size" },
      { id: "letto_singolo", emoji: "🛏️", label: "Letto singolo" },
      { id: "letto_castello", emoji: "🛏️", label: "Letto a castello" },
      { id: "letto_soppalco", emoji: "🪜", label: "Letto a soppalco" },
      { id: "divano_letto", emoji: "🛋️", label: "Divano letto" },
      { id: "culla", emoji: "👶", label: "Culla / lettino per neonati" },
      { id: "biancheria_cotone", emoji: "🛏️", label: "Biancheria da letto in cotone" },
      { id: "biancheria_cotone_egiziano", emoji: "✨", label: "Biancheria in cotone egiziano" },
      { id: "cuscini_memory", emoji: "🪶", label: "Cuscini in memory foam" },
      { id: "cuscini_ipoallergenici", emoji: "🌿", label: "Cuscini ipoallergenici" },
      { id: "cuscini_extra", emoji: "🪶", label: "Cuscini e coperte extra" },
      { id: "piumino", emoji: "🛏️", label: "Piumino" },
      { id: "tende_oscuranti", emoji: "🌑", label: "Tende oscuranti" },
      { id: "tende_blackout", emoji: "⬛", label: "Tende blackout totale" },
      { id: "armadio", emoji: "🚪", label: "Armadio con ante" },
      { id: "cassettiera", emoji: "🗄️", label: "Cassettiera" },
      { id: "grucce", emoji: "🪝", label: "Grucce" },
      { id: "comodino_lampada", emoji: "💡", label: "Comodino con lampada" },
      { id: "lampada_lettura", emoji: "📖", label: "Lampada da lettura" },
      { id: "appendiabiti", emoji: "🧥", label: "Appendiabiti a muro" },
      { id: "valigia_rack", emoji: "🧳", label: "Porta valigie / luggage rack" },
      { id: "guardaroba_walkin", emoji: "🚶", label: "Guardaroba walk-in" },
      { id: "ferro_stiro", emoji: "🧺", label: "Ferro da stiro" },
      { id: "asse_stiro", emoji: "🧺", label: "Asse da stiro" },
      { id: "stendibiancheria", emoji: "👔", label: "Stendibiancheria" },
      { id: "specchio_figura_intera", emoji: "🪞", label: "Specchio a figura intera" },
      { id: "prese_usb_letto", emoji: "🔌", label: "Prese USB vicino al letto" },
      { id: "scrivania_camera", emoji: "🖥️", label: "Scrivania in camera" },
      { id: "cassaforte_camera", emoji: "🔒", label: "Cassaforte in camera" },
      { id: "ventilatore_camera", emoji: "💨", label: "Ventilatore in camera" },
    ],
  },
  {
    id: "lavanderia", label: "Lavanderia", emoji: "🧺",
    items: [
      { id: "lavatrice", emoji: "🫧", label: "Lavatrice gratuita (nell'alloggio)" },
      { id: "asciugatrice", emoji: "♨️", label: "Asciugatrice" },
      { id: "lavatrice_asciugatrice", emoji: "🔄", label: "Lavatrice/asciugatrice combo" },
      { id: "detersivo", emoji: "🧴", label: "Detersivo incluso" },
      { id: "ammorbidente", emoji: "🌸", label: "Ammorbidente incluso" },
      { id: "lavanderia_gettoni_vicino", emoji: "🏪", label: "Lavanderia a gettoni nelle vicinanze" },
      { id: "lavanderia_gettoni_palazzo", emoji: "🏢", label: "Lavanderia a gettoni nel palazzo" },
      { id: "servizio_lavanderia", emoji: "👔", label: "Servizio lavanderia a pagamento" },
      { id: "cesto_biancheria", emoji: "🧺", label: "Cesto portabiancheria" },
      { id: "stiratrice", emoji: "👗", label: "Stiratrice professionale" },
    ],
  },
  {
    id: "cucina", label: "Cucina", emoji: "🍳",
    items: [
      { id: "cucina_completa", emoji: "🍳", label: "Cucina completa" },
      { id: "cucina_americana", emoji: "🏠", label: "Cucina americana open space" },
      { id: "piano_gas", emoji: "🔥", label: "Piano cottura a gas" },
      { id: "piano_induzione", emoji: "⚡", label: "Piano cottura a induzione" },
      { id: "piano_vetroceramica", emoji: "🔵", label: "Piano cottura in vetroceramica" },
      { id: "forno", emoji: "🥘", label: "Forno tradizionale" },
      { id: "forno_acciaio", emoji: "🔲", label: "Forno in acciaio inossidabile" },
      { id: "forno_convezione", emoji: "💨", label: "Forno a convezione" },
      { id: "microonde", emoji: "📡", label: "Forno a microonde" },
      { id: "frigo", emoji: "🧊", label: "Frigorifero" },
      { id: "frigo_americano", emoji: "🧊", label: "Frigorifero americano (side-by-side)" },
      { id: "congelatore", emoji: "❄️", label: "Congelatore" },
      { id: "lavastoviglie", emoji: "🍽️", label: "Lavastoviglie" },
      { id: "bollitore", emoji: "☕", label: "Bollitore elettrico" },
      { id: "macchina_caffe_capsule", emoji: "☕", label: "Macchina caffè (capsule/cialde)" },
      { id: "macchina_filtro", emoji: "☕", label: "Macchina caffè a filtro" },
      { id: "moka", emoji: "☕", label: "Moka" },
      { id: "nespresso", emoji: "☕", label: "Macchina Nespresso" },
      { id: "espresso_pro", emoji: "☕", label: "Macchina espresso professionale" },
      { id: "french_press", emoji: "☕", label: "French press" },
      { id: "frullatore", emoji: "🫙", label: "Frullatore" },
      { id: "frullatore_immersione", emoji: "🫙", label: "Frullatore a immersione" },
      { id: "robot_cucina", emoji: "⚙️", label: "Robot da cucina" },
      { id: "centrifuga", emoji: "🍊", label: "Centrifuga / estrattore succhi" },
      { id: "tostapane", emoji: "🍞", label: "Tostapane" },
      { id: "friggitrice_aria", emoji: "💨", label: "Friggitrice ad aria" },
      { id: "friggitrice", emoji: "🍟", label: "Friggitrice tradizionale" },
      { id: "pentola_pressione", emoji: "♨️", label: "Pentola a pressione" },
      { id: "slow_cooker", emoji: "🍲", label: "Slow cooker" },
      { id: "griglia_elettrica", emoji: "🥩", label: "Griglia elettrica da tavolo" },
      { id: "bbq_gas", emoji: "🔥", label: "Barbecue a gas" },
      { id: "bbq_carbonella", emoji: "🔥", label: "Barbecue a carbonella" },
      { id: "pentole_padelle", emoji: "🍳", label: "Pentole e padelle complete" },
      { id: "wok", emoji: "🥘", label: "Wok" },
      { id: "coltelli", emoji: "🔪", label: "Set coltelli da cucina" },
      { id: "tagliere", emoji: "🟫", label: "Tagliere" },
      { id: "colino", emoji: "🫙", label: "Colino / scolapasta" },
      { id: "teglie_forno", emoji: "🟫", label: "Teglie da forno" },
      { id: "piatti_posate", emoji: "🍽️", label: "Piatti e posate completi" },
      { id: "bicchieri_acqua", emoji: "🥛", label: "Bicchieri da acqua" },
      { id: "calici_vino", emoji: "🍷", label: "Calici da vino" },
      { id: "flute_champagne", emoji: "🥂", label: "Flûte da champagne" },
      { id: "boccali_birra", emoji: "🍺", label: "Boccali da birra" },
      { id: "servizio_te", emoji: "🫖", label: "Servizio da tè / teiera" },
      { id: "tavolo_pranzo_4", emoji: "🪑", label: "Tavolo da pranzo (4 posti)" },
      { id: "tavolo_pranzo_6", emoji: "🪑", label: "Tavolo da pranzo (6+ posti)" },
      { id: "tavolo_allungabile", emoji: "🪑", label: "Tavolo allungabile" },
      { id: "isola_cucina", emoji: "🏝️", label: "Isola cucina con sgabelli" },
      { id: "dispensa", emoji: "🗄️", label: "Dispensa / credenza" },
      { id: "olio_sale_pepe", emoji: "🧂", label: "Olio, sale e pepe (forniti)" },
      { id: "caffe_te_zucchero", emoji: "☕", label: "Caffè, tè e zucchero (forniti)" },
      { id: "acqua_benvenuto", emoji: "💧", label: "Acqua in bottiglia (fornita)" },
      { id: "cesto_benvenuto", emoji: "🎁", label: "Cesto di benvenuto con prodotti locali" },
      { id: "cantinetta_vini", emoji: "🍷", label: "Cantinetta / porta bottiglie vini" },
      { id: "macchina_ghiaccio", emoji: "🧊", label: "Macchina per il ghiaccio" },
      { id: "distributore_acqua", emoji: "💧", label: "Distributore acqua filtrata" },
    ],
  },
  {
    id: "soggiorno", label: "Soggiorno", emoji: "🛋️",
    items: [
      { id: "divano_3posti", emoji: "🛋️", label: "Divano (3 posti)" },
      { id: "divano_angolare", emoji: "🛋️", label: "Divano angolare" },
      { id: "poltrona", emoji: "💺", label: "Poltrona" },
      { id: "pouf", emoji: "🪑", label: "Pouf" },
      { id: "tavolino_caffe", emoji: "☕", label: "Tavolino da caffè" },
      { id: "libreria", emoji: "📚", label: "Libreria" },
      { id: "tappeto", emoji: "🟫", label: "Tappeto" },
      { id: "dimmer", emoji: "💡", label: "Illuminazione regolabile / dimmer" },
      { id: "ventilatore_soffitto", emoji: "💨", label: "Ventilatore a soffitto" },
      { id: "camino_legna", emoji: "🪵", label: "Camino a legna" },
      { id: "camino_gas", emoji: "🔥", label: "Camino a gas" },
      { id: "camino_elettrico", emoji: "⚡", label: "Camino elettrico / bioetanolo" },
      { id: "tavolo_gioco", emoji: "🎲", label: "Tavolo da gioco" },
      { id: "giochi_tavola", emoji: "🎲", label: "Giochi da tavolo" },
      { id: "biliardo", emoji: "🎱", label: "Biliardo" },
      { id: "biliardino", emoji: "⚽", label: "Calcio balilla / biliardino" },
      { id: "ping_pong", emoji: "🏓", label: "Ping pong" },
      { id: "piano_musicale", emoji: "🎹", label: "Piano / tastiera musicale" },
    ],
  },
  {
    id: "intrattenimento", label: "Intrattenimento", emoji: "📺",
    items: [
      { id: "smart_tv_4k", emoji: "📺", label: "Smart TV 4K" },
      { id: "hdtv_40", emoji: "📺", label: "HDTV 40\"" },
      { id: "hdtv_50", emoji: "📺", label: "HDTV 50\"" },
      { id: "hdtv_65", emoji: "📺", label: "HDTV 65\"+" },
      { id: "tv_camera", emoji: "📺", label: "TV in camera da letto" },
      { id: "tv_cucina", emoji: "📺", label: "TV in cucina" },
      { id: "netflix", emoji: "🎬", label: "Netflix" },
      { id: "amazon_prime", emoji: "🎬", label: "Amazon Prime Video" },
      { id: "disney_plus", emoji: "🎬", label: "Disney+" },
      { id: "apple_tv_plus", emoji: "🎬", label: "Apple TV+" },
      { id: "chromecast", emoji: "📡", label: "Chromecast" },
      { id: "apple_tv_device", emoji: "🍎", label: "Apple TV (dispositivo)" },
      { id: "fire_tv", emoji: "🔥", label: "Fire TV Stick" },
      { id: "sky_dazn", emoji: "📡", label: "Sky / DAZN" },
      { id: "home_cinema", emoji: "🎬", label: "Impianto home cinema" },
      { id: "proiettore", emoji: "📽️", label: "Proiettore con schermo" },
      { id: "sistema_sonos", emoji: "🔊", label: "Sistema audio Sonos" },
      { id: "sistema_bluetooth", emoji: "🔊", label: "Sistema audio Bluetooth + AUX" },
      { id: "casse_bluetooth", emoji: "🔊", label: "Casse Bluetooth portatili" },
      { id: "vinili_giradischi", emoji: "🎵", label: "Vinili e giradischi" },
      { id: "libri", emoji: "📚", label: "Libri e materiale di lettura" },
      { id: "ps5", emoji: "🎮", label: "PlayStation 5" },
      { id: "xbox", emoji: "🎮", label: "Xbox Series X" },
      { id: "nintendo_switch", emoji: "🎮", label: "Nintendo Switch" },
      { id: "vr_headset", emoji: "🥽", label: "VR Headset" },
      { id: "karaoke", emoji: "🎤", label: "Karaoke" },
      { id: "stanza_tema", emoji: "🎨", label: "Stanza a tema" },
    ],
  },
  {
    id: "internet_ufficio", label: "Internet e Ufficio", emoji: "🌐",
    items: [
      { id: "wifi", emoji: "📶", label: "WiFi gratuito" },
      { id: "wifi_veloce", emoji: "📶", label: "WiFi alta velocità (100+ Mbps)" },
      { id: "wifi_ultraveloce", emoji: "📶", label: "WiFi ultra-veloce (500+ Mbps)", desc: "Fibra ottica. Streaming 4K e videochiamate senza interruzioni" },
      { id: "ethernet", emoji: "🔌", label: "Connessione Ethernet" },
      { id: "pocket_wifi", emoji: "📱", label: "Pocket WiFi / router portatile" },
      { id: "spazio_lavoro", emoji: "💼", label: "Spazio di lavoro dedicato" },
      { id: "scrivania_ergonomica", emoji: "🖥️", label: "Scrivania con sedia ergonomica" },
      { id: "monitor_aggiuntivo", emoji: "🖥️", label: "Monitor aggiuntivo" },
      { id: "stampante", emoji: "🖨️", label: "Stampante" },
      { id: "webcam", emoji: "📷", label: "Webcam" },
      { id: "microfono", emoji: "🎙️", label: "Microfono esterno" },
      { id: "prese_usb", emoji: "🔌", label: "Prese USB multiple" },
      { id: "caricatore_wireless", emoji: "🔋", label: "Caricatore wireless" },
      { id: "docking_station", emoji: "💻", label: "Docking station" },
    ],
  },
  {
    id: "clima", label: "Riscaldamento e Clima", emoji: "❄️",
    items: [
      { id: "ac_centralizzato", emoji: "❄️", label: "Aria condizionata centralizzata" },
      { id: "ac_split", emoji: "❄️", label: "Aria condizionata split (fisso)" },
      { id: "ac_finestra", emoji: "🪟", label: "Climatizzatore da finestra" },
      { id: "ac_portatile", emoji: "❄️", label: "Climatizzatore portatile" },
      { id: "pompa_calore", emoji: "🔄", label: "Pompa di calore" },
      { id: "riscaldamento_centralizzato", emoji: "🔥", label: "Riscaldamento centralizzato" },
      { id: "riscaldamento_pavimento", emoji: "🟫", label: "Riscaldamento a pavimento" },
      { id: "termosifoni", emoji: "🌡️", label: "Termosifoni" },
      { id: "stufa_pellet", emoji: "🪵", label: "Stufa a pellet" },
      { id: "stufa_legna", emoji: "🪵", label: "Stufa a legna" },
      { id: "ventilatore_portatile", emoji: "💨", label: "Ventilatore da pavimento portatile" },
      { id: "umidificatore", emoji: "💧", label: "Umidificatore" },
      { id: "deumidificatore", emoji: "💨", label: "Deumidificatore" },
      { id: "purificatore_aria", emoji: "🌿", label: "Purificatore d'aria" },
      { id: "termostato_smart", emoji: "📱", label: "Termostato smart (Nest / Ecobee)" },
    ],
  },
  {
    id: "sicurezza", label: "Sicurezza", emoji: "🔒",
    items: [
      { id: "smart_lock", emoji: "🔐", label: "Serratura smart con codice" },
      { id: "impronta_digitale", emoji: "👆", label: "Serratura con impronte digitali" },
      { id: "key_box", emoji: "🗝️", label: "Cassetta porta chiavi (key box)" },
      { id: "videocitofono", emoji: "📷", label: "Videocitofono" },
      { id: "citofono", emoji: "📞", label: "Citofono audio" },
      { id: "telecamere_esterne", emoji: "📷", label: "Telecamere sorveglianza esterne", desc: "Telecamera esterna, visibile agli ospiti" },
      { id: "allarme", emoji: "🚨", label: "Allarme antifurto" },
      { id: "rilevatore_fumo", emoji: "🔥", label: "Rilevatore di fumo" },
      { id: "rilevatore_co", emoji: "💨", label: "Rilevatore di monossido di carbonio" },
      { id: "rilevatore_gas", emoji: "⚠️", label: "Rilevatore di gas" },
      { id: "estintore", emoji: "🧯", label: "Estintore" },
      { id: "kit_pronto_soccorso", emoji: "🩹", label: "Kit di primo soccorso" },
      { id: "illuminazione_sensore", emoji: "💡", label: "Illuminazione esterna con sensore" },
      { id: "cancello_elettrico", emoji: "🚗", label: "Cancello elettrico con telecomando" },
      { id: "porta_blindata", emoji: "🚪", label: "Porta blindata" },
      { id: "cassaforte", emoji: "🔒", label: "Cassaforte in camera" },
    ],
  },
  {
    id: "esterni", label: "Spazi Esterni", emoji: "🏡",
    items: [
      { id: "terrazzo_privato", emoji: "🌅", label: "Terrazzo privato" },
      { id: "balcone_privato", emoji: "🌿", label: "Balcone privato" },
      { id: "giardino_privato", emoji: "🌳", label: "Giardino privato" },
      { id: "giardino_condiviso", emoji: "🌳", label: "Giardino condiviso" },
      { id: "patio", emoji: "🪑", label: "Patio" },
      { id: "veranda", emoji: "🏠", label: "Veranda" },
      { id: "pergolato", emoji: "🌿", label: "Pergolato" },
      { id: "gazebo", emoji: "⛺", label: "Gazebo" },
      { id: "bbq_esterno", emoji: "🔥", label: "Barbecue esterno" },
      { id: "zona_pranzo_esterna", emoji: "🍽️", label: "Zona pranzo esterna" },
      { id: "salotto_esterno", emoji: "🛋️", label: "Salotto esterno" },
      { id: "amaca", emoji: "🌴", label: "Amaca" },
      { id: "altalena", emoji: "🎠", label: "Altalena" },
      { id: "dondolo", emoji: "🪑", label: "Dondolo da esterno" },
      { id: "vasca_idro_esterna", emoji: "🛁", label: "Vasca idromassaggio esterna (hot tub)" },
      { id: "piscina_privata", emoji: "🏊", label: "Piscina privata" },
      { id: "piscina_riscaldata", emoji: "🏊", label: "Piscina riscaldata" },
      { id: "piscina_condivisa", emoji: "🏊", label: "Piscina condivisa" },
      { id: "jacuzzi_esterna", emoji: "💦", label: "Jacuzzi esterna" },
      { id: "doccia_esterna", emoji: "🚿", label: "Doccia esterna" },
      { id: "sauna", emoji: "🧖", label: "Sauna finlandese" },
      { id: "sauna_infrarossi", emoji: "🌡️", label: "Sauna a infrarossi" },
      { id: "hammam", emoji: "💆", label: "Bagno turco (hammam)" },
    ],
  },
  {
    id: "parcheggio", label: "Parcheggio", emoji: "🅿️",
    items: [
      { id: "posto_auto_privato", emoji: "🅿️", label: "Posto auto privato" },
      { id: "garage_privato", emoji: "🚗", label: "Parcheggio privato gratuito (garage)" },
      { id: "parcheggio_privato", emoji: "🅿️", label: "Parcheggio privato a pagamento" },
      { id: "parcheggio_strada", emoji: "🛣️", label: "Parcheggio gratuito in strada" },
      { id: "parcheggio_condominiale", emoji: "🏢", label: "Parcheggio condominiale" },
      { id: "posto_coperto", emoji: "🏠", label: "Posto auto coperto" },
      { id: "posto_camper", emoji: "🚐", label: "Posto per camper / van" },
      { id: "posto_moto", emoji: "🏍️", label: "Posto moto" },
      { id: "rastrelliera_bici", emoji: "🚲", label: "Rastrelliera biciclette" },
      { id: "colonnina_ev", emoji: "⚡", label: "Colonnina ricarica auto elettrica" },
    ],
  },
  {
    id: "bambini", label: "Bambini e Famiglie", emoji: "👶",
    items: [
      { id: "culla_lettino", emoji: "👶", label: "Culla / lettino per bambini" },
      { id: "seggiolone", emoji: "🪑", label: "Seggiolone" },
      { id: "vasca_bambini", emoji: "🛁", label: "Vasca da bagno per bambini" },
      { id: "cancelletti_sicurezza", emoji: "🚧", label: "Cancelletti di sicurezza (scale)" },
      { id: "protezioni_prese", emoji: "🔌", label: "Protezioni per prese elettriche" },
      { id: "libri_bambini", emoji: "📚", label: "Libri per bambini" },
      { id: "giocattoli", emoji: "🧸", label: "Giocattoli" },
      { id: "giochi_tavola_bambini", emoji: "🎲", label: "Giochi da tavolo per bambini" },
      { id: "bici_bambini", emoji: "🚲", label: "Bici / monopattino per bambini" },
      { id: "baby_monitor", emoji: "📷", label: "Baby monitor" },
      { id: "passeggino", emoji: "👶", label: "Passeggino disponibile" },
    ],
  },
  {
    id: "accessibilita", label: "Accessibilità", emoji: "♿",
    items: [
      { id: "entrata_senza_gradini", emoji: "♿", label: "Entrata accessibile senza gradini" },
      { id: "maniglie_bagno", emoji: "🤝", label: "Maniglie di supporto in bagno" },
      { id: "doccia_accessibile", emoji: "🚿", label: "Doccia accessibile (senza bordo)" },
      { id: "sedia_doccia", emoji: "🪑", label: "Sedia da doccia" },
      { id: "ascensore", emoji: "🛗", label: "Ascensore nel palazzo" },
      { id: "pavimento_antiscivolo", emoji: "🟫", label: "Pavimento antiscivolo" },
      { id: "parcheggio_disabili", emoji: "♿", label: "Parcheggio per disabili" },
      { id: "porte_larghe", emoji: "🚪", label: "Porte larghe (80+ cm)" },
      { id: "casa_piano_terra", emoji: "🏠", label: "Casa su un solo piano (no scale)" },
    ],
  },
  {
    id: "sostenibilita", label: "Sostenibilità", emoji: "🌿",
    items: [
      { id: "pannelli_solari", emoji: "☀️", label: "Pannelli solari" },
      { id: "elettrodomestici_basso_consumo", emoji: "⚡", label: "Elettrodomestici a basso consumo" },
      { id: "raccolta_differenziata", emoji: "♻️", label: "Raccolta differenziata" },
      { id: "prodotti_eco", emoji: "🌿", label: "Prodotti pulizia eco-biologici" },
      { id: "prodotti_ricaricabili", emoji: "🧴", label: "Prodotti bagno in formato ricaricabile" },
      { id: "orto_biologico", emoji: "🥦", label: "Orto / giardino biologico" },
      { id: "ricarica_ev", emoji: "⚡", label: "Ricarica EV inclusa" },
    ],
  },
  {
    id: "fitness", label: "Fitness e Benessere", emoji: "🏋️",
    items: [
      { id: "palestra_privata", emoji: "💪", label: "Palestra privata nell'alloggio" },
      { id: "palestra_condominiale", emoji: "🏋️", label: "Palestra condominiale" },
      { id: "attrezzatura_fitness", emoji: "🏋️", label: "Attrezzatura fitness (pesi, tappeto)" },
      { id: "stuoia_yoga", emoji: "🧘", label: "Stuoia per yoga / pilates" },
      { id: "campo_tennis", emoji: "🎾", label: "Campo da tennis privato" },
      { id: "campo_tennis_condiviso", emoji: "🎾", label: "Campo da tennis condiviso" },
      { id: "campo_padel", emoji: "🏓", label: "Campo da padel" },
      { id: "campo_basket", emoji: "🏀", label: "Campo da basket" },
      { id: "spiaggia_privata", emoji: "🏖️", label: "Accesso a spiaggia privata" },
      { id: "canoe_kayak", emoji: "🚣", label: "Canoe / kayak disponibili" },
      { id: "sup", emoji: "🏄", label: "Tavole SUP (stand-up paddle)" },
      { id: "snorkeling", emoji: "🤿", label: "Attrezzatura da snorkeling" },
      { id: "biciclette", emoji: "🚲", label: "Biciclette disponibili" },
      { id: "bici_elettriche", emoji: "⚡", label: "Biciclette elettriche disponibili" },
      { id: "attrezzatura_sci", emoji: "⛷️", label: "Attrezzatura da sci disponibile" },
    ],
  },
  {
    id: "servizi_politiche", label: "Servizi e Politiche", emoji: "🎯",
    items: [
      { id: "animali_ammessi", emoji: "🐾", label: "Animali domestici ammessi", desc: "Gli animali di servizio sono sempre ammessi" },
      { id: "animali_piccola_taglia", emoji: "🐕", label: "Animali piccola taglia ammessi" },
      { id: "soggiorni_lunghi", emoji: "📅", label: "Soggiorni a lungo termine (28+ giorni)" },
      { id: "self_checkin", emoji: "🔑", label: "Self check-in" },
      { id: "checkin_flessibile", emoji: "⏰", label: "Check-in flessibile" },
      { id: "checkin_24h", emoji: "🕐", label: "Check-in 24h" },
      { id: "portiere", emoji: "👨‍💼", label: "Portiere / concierge disponibile" },
      { id: "pulizie_incluse", emoji: "🧹", label: "Servizio di pulizia incluso" },
      { id: "pulizie_meta_soggiorno", emoji: "🧹", label: "Pulizie a metà soggiorno" },
      { id: "cambio_biancheria", emoji: "🛏️", label: "Cambio biancheria settimanale" },
      { id: "transfer_aeroporto", emoji: "✈️", label: "Transfer aeroportuale su richiesta" },
      { id: "noleggio_bici", emoji: "🚲", label: "Noleggio biciclette" },
      { id: "noleggio_auto", emoji: "🚗", label: "Noleggio scooter / auto" },
      { id: "personal_chef", emoji: "👨‍🍳", label: "Personal chef su richiesta" },
      { id: "guida_turistica", emoji: "🗺️", label: "Guida turistica su richiesta" },
      { id: "babysitter", emoji: "👶", label: "Baby-sitter su richiesta" },
      { id: "guida_quartiere", emoji: "📍", label: "Guida locale e consigli di quartiere" },
      { id: "vista_mare", emoji: "🌊", label: "Vista sul mare" },
      { id: "vista_lago", emoji: "🏞️", label: "Vista sul lago" },
      { id: "vista_montagna", emoji: "⛰️", label: "Vista sulla montagna" },
      { id: "vista_urbana", emoji: "🌆", label: "Vista sul panorama urbano" },
      { id: "vista_giardino", emoji: "🌳", label: "Vista sul giardino" },
      { id: "vista_piscina", emoji: "🏊", label: "Vista sulla piscina" },
      { id: "vista_bosco", emoji: "🌲", label: "Vista sul bosco / natura" },
    ],
  },
];

export { AMENITIES_DATA };
export default AMENITIES_DATA;
